import { AppWidgetState, moTradeReleaseCommentFieldId } from '@ddv/models';

export function removeTradeReleaseComment(widgetInfo: AppWidgetState, costCenter: string | undefined): void {
    if (costCenter !== 'Middle Office') {
        widgetInfo.visualizationConfigs.forEach((vc) => {
            if (!vc.configs?.values.length) {
                return;
            }

            vc.configs.values = vc.configs.values.filter((v) => v.value !== moTradeReleaseCommentFieldId);
        });
    }
}
